<template>
  <div v-if="isLoading" class="loading-wrapper">
    <img src="../../assets/img/loading-no-bg.gif" alt="loading-icon" class="loading-icon">
  </div>
</template>

<script>
export default {
  name: 'LoadingComponent',
  props: {
    isLoading: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
.loading-wrapper {
  background-color: rgba(0, 0, 0, 0.1);
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-icon {
  width: 15px;
  height: 15px;
}
</style>
